import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CognitoAuthService } from './shared';
import {
    AlertsComponent,
    CustomerReportComponent,
    CustomerReportMobileComponent,
    DashboardComponent,
    EventsComponent,
    ForgotPasswordComponent,
    InsightComponent,
    InsightDetailComponent,
    LogsComponent,
    MainComponent,
    PageNotFoundComponent,
    SignInComponent,
    UserProfileComponent
} from './containers';


const appRoutes: Routes = [
    /*
    { path: 'hero/:id', component: HeroDetailComponent },
    { path: 'crisis-center', component: CrisisCenterComponent },
    {
        path: 'heroes',
        component: HeroListComponent,
        data: {
            title: 'Heroes List'
        }
    },
    */
    {
        path: '',
        component: MainComponent,
        canActivateChild: [ CognitoAuthService ],
        children: [
            {
                path: 'dashboard',
                component: DashboardComponent
            },
            {
                path: 'insight/:ip',
                component: InsightDetailComponent
            },
            {
                path: 'insight',
                component: InsightComponent
            },
            {
                path: 'alerts',
                component: AlertsComponent
            },
            {
                path: 'events',
                component: EventsComponent
            },
            {
                path: 'logs',
                component: LogsComponent
            },
            {
                path: 'user-profile',
                component: UserProfileComponent
            },
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            }
        ]

    },
    /*
    {
        path: 'events',
        component: MainComponent,
        canActivate: [ AuthService ],
        children: [
            {
                path: '',
                component: EventsComponent
            }
        ]
    },
    */
    { path: 'sign-in', component: SignInComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'customer-report', component: CustomerReportComponent },
    { path: 'customer-report-mobile', component: CustomerReportMobileComponent },
    { path: '**', component: PageNotFoundComponent }
];

export const appRoutingProviders: any[ ] = [

];

export const routedComponents = [
    AlertsComponent,
    CustomerReportComponent,
    CustomerReportMobileComponent,
    DashboardComponent,
    EventsComponent,
    ForgotPasswordComponent,
    InsightComponent,
    InsightDetailComponent,
    LogsComponent,
    MainComponent,
    PageNotFoundComponent,
    SignInComponent,
    UserProfileComponent
];
// export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes, { useHash: true, enableTracing: true });
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes, { useHash: true });



// WEBPACK FOOTER //
// /app/src/app/app.routing.ts